import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { FileText, ExternalLink } from 'lucide-react';

const Publications = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="publications"
      ref={sectionRef}
      className="section-padding py-20 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="section-title text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="text-cyan-400 font-mono text-lg">05.</span> Publications
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mb-12"></div>

          <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-400/10">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="p-4 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                  <FileText className="w-8 h-8 text-cyan-400" />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-4 flex-wrap">
                    <div>
                      <h3 className="text-xl font-bold text-white mb-2">
                        Utilization and Comparison of Convolutional Neural Networks in Malware Recognition
                      </h3>
                      <p className="text-cyan-400 font-semibold mb-2">IEEE</p>
                      <p className="text-gray-400">Published in 2019</p>
                    </div>
                    <ExternalLink className="w-5 h-5 text-gray-400 hover:text-cyan-400 transition-colors duration-300 cursor-pointer" />
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Publications;